import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Para cambiar el video: reemplaza el ID de YouTube abajo
const YOUTUBE_VIDEO_ID = '_NxmyxXSqII';

const VIDEO_THUMBNAIL = 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/633b004704a6b64e716e576685a5e3ff.png';

export default function CommunityPreview() {
  const navigate = useNavigate();
  const [videoPlaying, setVideoPlaying] = useState(false);

  return (
    <section className="py-20 bg-[#1C1C1C] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-14 items-center">
          {/* Left image */}
          <div className="w-full lg:w-[45%]">
            <div className="relative rounded-2xl overflow-hidden h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=community%20painting%20project%20volunteers%20helping%20local%20family%20Wellington%20New%20Zealand%20painters%20giving%20back%20community%20service%20team%20painting%20house%20together%20warm%20sunny%20day%20neighbourhood%20improvement&width=700&height=420&seq=comm2001&orientation=landscape"
                alt="ALFA Decorators community work Wellington"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <div className="bg-white/15 backdrop-blur-sm border border-white/20 rounded-xl p-4">
                  <div className="text-2xl font-black text-white"></div>
                  <div className="text-white/75 text-sm">Community projects completed across Wellington &amp; Hutt Valley</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right content */}
          <div className="w-full lg:w-[55%]">
            <span className="inline-block text-gray-400 text-sm font-semibold tracking-widest uppercase mb-4">Community Work</span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-5 tracking-tight">
              Supporting Our<br />Community
            </h2>
            <p className="text-white/65 text-lg mb-4 leading-relaxed">
              We don&apos;t just paint homes — we help improve lives.
            </p>
            <p className="text-white/55 text-base leading-relaxed mb-8">
              At ALFA Decorators, we believe in giving back to the community that supports us. Through our Community Homes Program, we provide painting and maintenance services to local families, community spaces, and people in need. We are proud to make a positive impact across Wellington and the Hutt Valley.
            </p>

            <ul className="space-y-3 mb-10">
              {[
                'Supporting local families in need',
                'Helping community spaces look their best',
                'Making a real difference in our neighbourhoods',
              ].map((point) => (
                <li key={point} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#2D2D2D] flex-shrink-0">
                    <i className="ri-check-line text-white text-xs" />
                  </div>
                  <span className="text-white/75 text-sm">{point}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/community"
                onClick={(e) => { e.preventDefault(); navigate('/community'); }}
                className="px-7 py-3.5 bg-white text-[#1C1C1C] font-bold rounded-full whitespace-nowrap hover:bg-gray-100 transition-colors cursor-pointer text-sm text-center"
              >
                View Community Projects
              </a>
              <a
                href="/contact"
                onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                className="px-7 py-3.5 border-2 border-white/30 text-white font-bold rounded-full whitespace-nowrap hover:border-white/60 hover:bg-white/10 transition-colors cursor-pointer text-sm text-center"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>

        {/* Video Section */}
        <div className="mt-20">
          <div className="text-center mb-8">
            <span className="inline-block text-gray-400 text-sm font-semibold tracking-widest uppercase mb-3">Watch Our Work</span>
            <h3 className="text-3xl md:text-4xl font-black text-white">See the Impact We Make</h3>
          </div>

          <div className="flex justify-center">
          <div className="relative rounded-2xl overflow-hidden bg-black w-full max-w-[420px]" style={{ aspectRatio: '9/16' }}>
            {!videoPlaying ? (
              <button
                type="button"
                onClick={() => setVideoPlaying(true)}
                className="relative w-full h-full cursor-pointer group border-0 p-0 block"
                style={{ aspectRatio: '9/16' }}
              >
                <img
                  src={VIDEO_THUMBNAIL}
                  alt="Community project video thumbnail"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/45 group-hover:bg-black/55 transition-colors" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-20 h-20 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm border-2 border-white/50 group-hover:bg-white/30 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-play-fill text-white text-4xl ml-1" />
                  </div>
                </div>
                <div className="absolute bottom-5 left-1/2 -translate-x-1/2">
                  <span className="text-white/70 text-xs font-medium tracking-widest uppercase">Click to play</span>
                </div>
              </button>
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0`}
                title="Community project video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            )}
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}
